import { Col, Container, Row } from '@bootstrap-styled/v4';
import React, { useState } from 'react';
import colors from 'shared-components/theme/colors';
import {
    gilroyBold,
    gilroyMedium,
    gilroyRegular,
} from 'shared-components/theme/fonts';
import { baseURL } from 'shared-components/theme/helpers';
import Media from 'shared-components/theme/medias';
import styled from 'styled-components';
import SectionTitle from './section-tag';
import IntroductionTitle from './introduction-title';
import IntroductionDesc from './introduction-desc';
import CustomVideoPlayer from 'components/custom-video-player/custom-video-player';
import CountUp from 'react-countup';
import ScrollAnimation from 'react-animate-on-scroll';
const IntroStatisitcs = () => {
    const [playing, setPlaying] = useState(false);
    const full = '98%';
    return (
        <Wrap id="whypk">
            <Container>
                <Row>
                    <Col lg="5">
                        <IntroLeft>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}>
                                <SectionTitle tag={'VIDEO'} />
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}
                                delay={100}>
                                <IntroductionTitle
                                    title={
                                        'Grounded in Heritage. Driven by Innovation. Designed for the World.'
                                    }
                                />
                            </ScrollAnimation>
                        </IntroLeft>
                    </Col>
                    <Col lg="7">
                        <IntroRight>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}
                                delay={150}>
                                <VideoWrap playing={playing}>
                                    <p>
                                        Pakistan Rising: <br /> The Hidden Gem
                                        Cutting Costs by 90%
                                    </p>
                                    <CustomVideoPlayer
                                        poster={`${baseURL}assets/images/geos/pakistan/vid-thumb.png`}
                                        videoSource={`${baseURL}assets/images/geos/pakistan/pk-talent.mp4`}
                                        playing={playing}
                                        setPlaying={setPlaying}
                                        isControlVisible={true}
                                        showOverlay={false}
                                        showVolume={false}
                                        seekControlWidth={full}
                                        showPassedTime={false}
                                        showCenterBtn={true}
                                        padding={'20px 20px 18px'}
                                        height={'3px'}
                                        progressBg={colors.geoGreen[50]}
                                    />
                                </VideoWrap>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}
                                delay={200}>
                                <IntroductionDesc
                                    desc={
                                        'CX is a respected career here — Pakistan’s agents are proud, performance-minded, global-ready, digitally native professionals powering the future of customer experience.'
                                    }
                                />
                            </ScrollAnimation>
                        </IntroRight>
                    </Col>
                </Row>

                <QuickStats id="quickfacts">
                    <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                        <IntroductionTitle title={'Quick Stats'} />
                    </ScrollAnimation>
                    <Row>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            animateOnce={true}
                            delay={200}>
                            <StatsContainer>
                                <StatContainer>
                                    <img
                                        src={`${baseURL}assets/images/geos/pakistan/stat_ico1.svg`}
                                        width={56}
                                        height={56}
                                        loading="lazy"
                                    />
                                    <div>
                                        <h2 className="stats_count">
                                            <CountUp
                                                start={0}
                                                end={250}
                                                suffix="K"
                                                enableScrollSpy={true}
                                                scrollSpyOnce={true}
                                            />
                                        </h2>
                                        <p className="stats_desc">
                                            grads/year with 35K+ in IT
                                        </p>
                                    </div>
                                </StatContainer>

                                <StatContainer>
                                    <img
                                        src={`${baseURL}assets/images/geos/pakistan/stat_ico2.svg`}
                                        width={56}
                                        height={56}
                                        loading="lazy"
                                    />
                                    <div>
                                        <h2 className="stats_count">
                                            <CountUp
                                                start={0}
                                                end={60}
                                                suffix="%"
                                                enableScrollSpy={true}
                                                scrollSpyOnce={true}
                                            />
                                        </h2>
                                        <p className="stats_desc">
                                            population under 25
                                        </p>
                                    </div>
                                </StatContainer>

                                <StatContainer>
                                    <h2 className="stats_count">
                                        <CountUp
                                            start={0}
                                            end={88}
                                            suffix="%"
                                            enableScrollSpy={true}
                                            scrollSpyOnce={true}
                                        />
                                    </h2>
                                    <div>
                                        <p className="stats_desc">
                                            English Fluency
                                        </p>
                                        <p className="stats_desc">
                                            Other Languages: Arabic, French,
                                            German, Mandarin
                                        </p>
                                    </div>
                                </StatContainer>

                                <StatContainer>
                                    <img
                                        src={`${baseURL}assets/images/geos/pakistan/stat_ico3.svg`}
                                        width={56}
                                        height={56}
                                        loading="lazy"
                                    />
                                    <div>
                                        <h2 className="stats_count">
                                            ~
                                            <CountUp
                                                start={0}
                                                end={90}
                                                suffix="%"
                                                enableScrollSpy={true}
                                                scrollSpyOnce={true}
                                            />
                                        </h2>
                                        <p className="stats_desc">
                                            Cost Savings
                                        </p>
                                    </div>
                                </StatContainer>
                            </StatsContainer>
                        </ScrollAnimation>
                    </Row>
                </QuickStats>
            </Container>
        </Wrap>
    );
};

export default IntroStatisitcs;

const Wrap = styled.section`
    position: relative;
    z-index: 2;
    background: ${colors.geoGreen[100]};
    padding-bottom: 220px;
    padding-top: 140px;
    scroll-margin-top: 100px;
    ${Media('large')} {
        padding-bottom: 13.087vw;
        padding-top: 7.328vw;
    }

    @media (max-width: 1024px) {
        padding-bottom: 60px;
        padding-top: 60px;
    }
`;

const IntroLeft = styled.div`
    display: flex;
    flex-direction: column;

    ${Media('large')} {
        gap: 40px;
    }
`;

const VideoWrap = styled.div`
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    &:hover {
        p {
            opacity: 1;
        }
    }
    p {
        position: absolute;
        z-index: 1;
        top: 20px;
        left: 20px;
        width: 100%;
        margin: 0;
        color: ${colors.white[50]} !important;
        font-size: 16px;
        font-family: ${gilroyMedium};
        font-weight: 500;
        opacity: ${(props) => (props.playing ? 0 : 1)};
        ${Media('large')} {
            font-size: 0.952vw;
        }
        ${Media('mobile')} {
            font-size: 14px;
        }
    }
`;

const IntroRight = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

const QuickStats = styled.div`
    margin-top: 80px;
    scroll-margin-top: 100px;
`;

const StatsContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 14px;

    ${Media('mobile')} {
        flex-wrap: wrap;
        gap: 10px 6px;
    }
`;

const StatContainer = styled.div`
    border-radius: 10px;
    box-sizing: border-box;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 100px;
    transition: 0.3s ease;
    text-align: right;
    border: 1px solid transparent;
    ${Media('mobile')} {
        gap: 50px;
        padding: 20px 15px;
    }
    &:hover {
        transform: translateY(-6px);
        img {
            transform: scale(1.1);
        }
    }

    &:nth-of-type(1) {
        background: ${colors.geoWhite[100]};
        flex: 0 0 32%;
        .stats_count {
            font-size: 120px;

            @media (max-width: 1024px) {
                font-size: 70px;
            }
            ${Media('mobile')} {
                font-size: 50px;
            }
        }

        ${Media('mobile')} {
            flex: 0 0 52%;
        }
    }
    &:nth-of-type(2) {
        background: #3bf78a;
        flex: 0 0 21%;

        ${Media('mobile')} {
            flex: 0 0 37%;
        }
    }
    &:nth-of-type(3) {
        background: #042914;
        flex: 0 0 21%;
        ${Media('mobile')} {
            flex: 0 0 42%;
        }
        .stats_count {
            color: ${colors.geoWhite[100]};
        }

        .stats_desc:nth-child(1) {
            color: ${colors.geoWhite[100]};
        }
        .stats_desc:nth-child(2) {
            color: #106434;
        }
    }
    &:nth-of-type(4) {
        background: #01411c;
        flex: 0 0 21%;
        ${Media('mobile')} {
            flex: 0 0 47%;
        }
        .stats_count {
            color: #3bf78a;
        }
        .stats_desc {
            color: #3bf78a;
        }
    }

    img {
        display: block;
        margin-left: auto;
        transition: 0.3s ease;
    }

    .stats_count {
        font-size: 80px;
        font-weight: 700;
        font-family: ${gilroyBold};
        color: #04190d;
        margin: 0;

        @media (max-width: 1024px) {
            font-size: 50px;
        }

        ${Media('mobile')} {
            font-size: 30px;
        }
    }

    .stats_desc {
        font-size: 20px;
        font-family: ${gilroyRegular};
        font-weight: 400;
        margin: 0;
        ${Media('large')} {
            font-size: 1.309vw;
        }
        @media (max-width: 1024px) {
            font-size: 16px;
        }
    }
`;
